<template>
  <div class="hidden-danger-content">
    <el-dialog
      class="hidden-detail-dlialog"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="padding: 0"
    >
      <div class="content">
        <div class="hidden-close" @click="dialogVisible = false">
          关闭
        </div>
        <div class="content-title">
          <img src="@/assets/img/hiddenDangerNow/school-logo.png" alt="" />
          <span>{{ resData.schoolName }}</span>
        </div>
        <div class="detail">
          <div class="img">
            <div class="list-img">
              <div class="name">上报图：</div>
              <div class="img-url">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="
                    $store.state.config.fileUrl + resData.hiddenDangerImgUrl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl + resData.hiddenDangerImgUrl
                  ]"
                  :fit="'contain'"
                >
                </el-image>
              </div>
            </div>
            <div class="list-img" v-if="resData.hiddenDangerImgAfterurl">
              <div class="name">整改图：</div>
              <div class="img-url">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="
                    $store.state.config.fileUrl +
                      resData.hiddenDangerImgAfterurl
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl +
                      resData.hiddenDangerImgAfterurl
                  ]"
                  :fit="'contain'"
                >
                </el-image>
              </div>
            </div>
          </div>
          <div class="icon-list">
            <img class="icon-line" src="@/assets/img/hiddenDangerNow/rect-line.png" alt="" />
            <img
              class="list-li list-li-1"
              src="@/assets/img/hiddenDangerNow/report-icon.png"
              alt="上报"
            />
            <img
              class="list-li list-li-2"
              src="@/assets/img/hiddenDangerNow/time-icon.png"
              alt="上报时间"
            />
            <img
              class="list-li list-li-3"
              src="@/assets/img/hiddenDangerNow/description-icon.png"
              alt="描述"
            />
            <img
              class="list-li list-li-4"
              src="@/assets/img/hiddenDangerNow/status-icon.png"
              alt="状态"
            />
            <img
              class="list-li list-li-5"
              src="@/assets/img/hiddenDangerNow/label-icon.png"
              alt="类别"
            />
          </div>
          <div class="detail-content">
            <div class="detail-label">
              <div class="label-1">上报人：</div>
              <div class="label-2">上报时间：</div>
              <div class="label-3">描述：</div>
              <div class="label-4">状态：</div>
              <div class="label-5">类别：</div>
              <div class="label-6">处理时间</div>
            </div>
            <div class="tip">
              <div class="tip-1">
                {{ resData.reportUserName }}
              </div>
              <div class="tip-2">{{ resData.addTime }}</div>
              <div class="tip-3">
                {{ resData.hiddenDangerDescribe }}
                <span></span>
              </div>
              <div class="tip-4">
                <span v-if="resData.hiddenDangerStatus == 0">已上报</span>
                <span v-if="resData.hiddenDangerStatus == 1">已指派</span>
                <span v-if="resData.hiddenDangerStatus == 2">已处理</span>
                <span v-if="resData.hiddenDangerStatus == 3">已撤销</span>
                <span v-if="resData.hiddenDangerStatus == 4">已验收</span>
              </div>
              <div class="tip-5">
                <template
                  v-for="(item, index) in $store.state.select.hiddenDangerType"
                >
                  <span
                    :key="index"
                    v-if="resData.hiddenDangerClassifyName == item.id"
                    >{{ item.nameOne }}</span
                  >
                </template>
                <span v-if="resData.hiddenDangerClassifyName == 0">未选择</span>
              </div>
              <div class="tip-6">
                要求处理时间：<span
                  >{{
                    resData.completionTime != 0
                      ? resData.completionTime + "小时内"
                      : "立即处理"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "hiddenDangerNowDialog",
  components: {},
  props: {},
  data() {
    return {
      resData: {},
      dialogVisible: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    hiddenDangerIdResize() {
      return this.$store.state.hiddenDangerIdResize;
    },
    hiddenDangerId() {
      return this.$store.state.hiddenDangerId;
    }
  },
  watch: {
    hiddenDangerIdResize(newVal) {
      if (newVal) {
        this.getHazardDetails(this.hiddenDangerId);
      }
    }
  },
  methods: {
    async getHazardDetails(id) {
      let req = {
        id: id
      };
      let res = await this.$Http.hazardDetails(req);
      if (res.code == 200) {
        res.data.addTime = this.$Common.dateFormatDateTwo(res.data.addTime);
        this.resData = res.data;
        this.dialogVisible = true;
        // console.log(res.data);
      } else if (res.code == 101) {
      } else {
      }
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.hidden-danger-content {
  /deep/ .el-dialog {
    width: 882px;
    height: 550px;
    background: transparent;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      height: 100%;
      padding: 0;
    }
  }
}

.content {
  padding-top: 12px;
  width: 100%;
  height: 100%;
  // 已修改
  background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png") center center no-repeat;
  background-size: 100% 100%;
  position: relative;
  .hidden-close {
    width: 56px;
    height: 24px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #d7deff;
    line-height: 25px;
    text-align: center;
    letter-spacing: 1px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .content-title {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
    }
    span {
      margin-left: 16px;
      font-size: 24px;
      color: #ffff00;
    }
  }
  .detail {
    display: flex;
    justify-content: center;
  }
  .img {
    margin-top: 14px;
    width: 294px;
    height: 390px;
    padding: 24px 40px 40px 16px;
    box-shadow: 0px 0px 29px 0px rgba(153, 178, 255, 0.5) inset;
    border-radius: 1px;
    .list-img {
      text-align: left;
      margin-bottom: 22px;
      .name {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
        letter-spacing: 1px;
      }
      .img-url {
        margin-top: 14px;
        padding-left: 22px;
        .el-image {
          width: 216px;
          height: 118px;
        }
      }
    }
  }
  .icon-list {
    width: 40px;
    margin-left: 35px;
    margin-right: 36px;
    position: relative;
    top: 12px;
    .icon-line {
      height: 400px;
      position: absolute;
      top: 0;
      left: 17px;
      z-index: 2;
    }
    .list-li {
      display: block;
      width: 38px;
      height: 40px;
      position: relative;
      z-index: 3;
      &.list-li-1 {
        margin-bottom: 32px;
      }
      &.list-li-2 {
        margin-bottom: 32px;
      }
      &.list-li-3 {
        margin-bottom: 84px;
      }
      &.list-li-4 {
        margin-bottom: 32px;
      }
      &.list-li-5 {
        margin-bottom: 32px;
      }
    }
  }
  .detail-content {
    padding-top: 18px;
    display: flex;
    justify-content: flex-start;
    .detail-label {
      width: 103px;
      text-align: right;
      div {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        letter-spacing: 1px;
        &.label-1 {
          margin-bottom: 46px;
        }
        &.label-2 {
          margin-bottom: 48px;
        }
        &.label-3 {
          margin-bottom: 100px;
        }
        &.label-4 {
          margin-bottom: 48px;
        }
        &.label-6 {
          opacity: 0;
        }
      }
    }
    .tip {
      width: 250px;
      text-align: left;
      div {
        padding-bottom: 8px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #d7deff;
        line-height: 25px;
        letter-spacing: 1px;
        border-bottom: 1px solid rgba(120, 125, 233, 0.6);
        &.tip-1 {
          margin-bottom: 38px;
        }
        &.tip-2 {
          margin-bottom: 38px;
        }
        &.tip-3 {
          height: 93px;
          margin-bottom: 32px;
          overflow-y: scroll;
        }
        &.tip-4 {
          margin-bottom: 40px;
        }
        &.tip-5 {
          margin-bottom: 12px;
        }
        &.tip-6 {
          border-bottom: none;
          padding: 8px 13px;
          // box-shadow: 0px 0px 25px 0px rgba(8, 16, 58, 0.5) inset;
          background: url("~@/assets/img/hiddenDangerNow/big-data-handle-time-bg.png") center center
            no-repeat;
          background-size: 100% 100%;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffa9;
          line-height: 25px;
          letter-spacing: 1px;
          span {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #d7deff;
            line-height: 25px;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}
</style>
